<template>
    <Intersect @enter.once="load">
        <div>
            <div v-show="isLoading" class="sign-up-loader">
                <button class="btn transparent loading"></button>
            </div>

            <div v-if="styleHtml" v-html="styleHtml"></div>
            <component v-if="form" :is="form" />
        </div>
    </Intersect>
</template>

<script>
    import Vue from "vue";
    import Intersect from "vue-intersect";
    import Popup from "../util/Popup";

    export default {
        name: 'SignUpFormLoader',

        components: {Intersect, Popup},

        props: {
            url: {type: String, required: true},
        },

        data() {
            return {
                form: null,
                styleHtml: '',
                isLoading: false,
            };
        },

        methods: {
            async load() {
                try {
                    this.isLoading = true;

                    const response = await fetch(this.url);
                    const html = await response.text();

                    const parser = new DOMParser();
                    const dom = parser.parseFromString(html, 'text/html');

                    this.styleHtml = dom.getElementsByTagName('style')[0].outerHTML;
                    const formHtml = dom.getElementsByTagName('body')[0].innerHTML;

                    this.form = Vue.compile(formHtml);
                    this.form.methods = {
                        data() {
                            return {
                                activePopup: null
                            };
                        },
                        showPopup(popupRef, params = {}) {
                            this.$root.showPopup(popupRef, params);
                            if (!this.$refs.hasOwnProperty(popupRef)) {
                                console.warn('Invalid popup ref: ' + popupRef);
                                return;
                            }

                            if (this.activePopup) {
                                this.$refs[this.activePopup].hide();
                            }

                            this.$refs[popupRef].setParams(params);
                            this.$refs[popupRef].show();
                            this.activePopup = popupRef;
                        }
                    };
                } finally {
                    this.isLoading = false;
                }
            },
        },
    }
</script>

<style>
    .dynamic-sidebar.area-signup-form .checkout-step-box {
        position: static;
        padding: 0;
    }

    .sign-up-loader .btn.loading {
        margin: 20px;
    }

    .sign-up-loader .btn.loading::after {
        width: 80px;
        height: 80px;
        margin-top: -40px;
        margin-left: -40px;
        background-size: cover;
    }

    .dynamic-sidebar.area-signup-form .-ds-inner {
        padding-left: 0;
        padding-right: 0;
    }

    .dynamic-sidebar .-su-f {
        gap: 5px;
    }
    .dynamic-sidebar .-suf-step {
        margin-bottom: 5px;
    }
    .dynamic-sidebar .-suf-credentials-password {
        margin-top: 5px;
    }
    .dynamic-sidebar .-suf-plan-type {
        margin-bottom: 10px;
    }
    .dynamic-sidebar .-suf-plan-list {
        gap: 5px;
    }

    @media (min-width: 768px) {
        .dynamic-sidebar.area-signup-form .-ds-slide {
            max-height: 100vh;
            max-width: 490px;
        }

        .dynamic-sidebar.area-signup-form .-ds-inner {
            padding-left: 20px;
            padding-right: 20px;
            width: 490px;
        }

        .dynamic-sidebar .-su-f {
            gap: 15px;
        }
        .dynamic-sidebar .-suf-step {
            margin-bottom: 7px;
        }
        .dynamic-sidebar .-suf-credentials-password {
            margin-top: 15px;
        }
        .dynamic-sidebar .-suf-plan-type {
            margin-bottom: 25px;
        }
        .dynamic-sidebar .-suf-plan-list {
            gap: 10px;
        }
    }

    @media (max-width: 767px) {
      html[lang=de] .dynamic-sidebar.area-signup-form .-ds-inner {
        height: 564px;
      }

      .dynamic-sidebar.area-signup-form .-ds-inner {
        height: 495px;
      }

      .dynamic-sidebar.area-signup-form .-suf-checkout-button {
        margin-top: 0;
      }

      .dynamic-sidebar.area-signup-form .-suf-checkout {
        top: auto;
        bottom: 0;
        left: 0;
        right: 0;
        position: fixed;
        z-index: 999;
        margin: 0;
        padding: 0 10px calc(10px + (env(safe-area-inset-bottom) / 2));
        background: #181818;
        box-shadow: 0 0 16px 8px rgba(0, 0, 0, 1);
      }
    }
</style>
